const positionStickySupport = function() {
    var el = document.createElement('a'),
        mStyle = el.style;
    mStyle.cssText = "position:sticky;position:-webkit-sticky;position:-ms-sticky;";
    return mStyle.position.indexOf('sticky')!==-1;
}();

export default positionStickySupport;